import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router,} from '@angular/router';

/** One crumb of a route's `breadcrumb` data: its label and, for a link, its route. */
export interface Breadcrumb {
  label: string;
  route?: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs: Breadcrumb[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  private update() {
    const activated = this.findActivatedRoute(this.router.routerState.snapshot.root);
    if (activated) {
      this.build(activated);
    } else {
      this.clear();
    }
  }

  private findActivatedRoute(activated: ActivatedRouteSnapshot) {
    if (Object.prototype.hasOwnProperty.call(activated.data, 'breadcrumb')) {
      return activated;
    }
    for (let index = 0; index < activated.children.length; index++) {
      const route = this.findActivatedRoute(activated.children[index]);
      if (route) {
        return route;
      }
    }
    return null;
  }

  private build(activated: ActivatedRouteSnapshot) {
    const data = activated.data;
    if (Object.prototype.hasOwnProperty.call(data, 'breadcrumb')) {
      this.breadcrumbs = [];
      data.breadcrumb.forEach((breadcrumb: Breadcrumb) => {
        const copy = Object.assign({}, breadcrumb);
        if (Object.prototype.hasOwnProperty.call(copy, 'route')) {
          const params = copy.route.match(/(:[a-zA-Z]+)/g);
          if (params) {
            params.forEach((param) => {
              copy.route = copy.route.replace(param, activated.paramMap.get(param.substring(1)));
            });
          }
        }
        this.breadcrumbs.push(copy);
      });
    }
  }

  private clear() {
    this.breadcrumbs = [];
  }

  ngOnInit() {
    this.update();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.update();
      }
    });
  }
}
